export default theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2)
  },
  fieldError: {
    color: theme.palette.danger.main,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1)
  },
   utteranceItem: {
    padding: 6,
    borderLeft: "4px solid #fff",
    borderBottom: "1px solid #ececec",
    marginBottom: 2,
    fontSize: 13,
    flex:1,
    "&:hover":{
      backgroundColor: "rgb(253 253 253)"
    }
  }, 
   utteranceSuccess: {
    borderLeft: `4px solid ${theme.palette.success.light}`,
    backgroundColor: "#fff!important"

  },
  utteranceDanger: {
    borderLeft: `4px solid ${theme.palette.danger.light}`,
    backgroundColor: "#fff!important"

  },
  unactiveUtterance: {
    color: theme.palette.danger.light,
    fontStyle: "italic"
  },
  tooltipContainer: {
    padding: 10,
    position: "absolute",
    background: "#fff",
    borderRadius: 6,
    boxShadow: "0 2px 5px -1px gray"
  },
  modalTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "5px 5px 5px 20px"
  },
  modalTitleLight: {
    color: theme.palette.text.light,
  },
  tableTitles: {
    fontWeight: 500,
    display:"flex",
    padding:"25px 6px",
    fontSize: 15,
  },
  scrollSign: {
    fontSize: "1.8rem",
    color: "lightgray",
    textAlign: "center",
    padding: "2rem 0 40vh 0"
  },
  trainButton: {
    textAlign: "center",
    marginTop: "3rem"
  },
  formGroup: {
    "& .MuiToggleButton-root":{
      border: `1px solid ${theme.palette.text.veryLight}`,
    },
  },
  formGroupButtonRed:{
    "&:hover":{
      color: theme.palette.danger.main,
      background: "#fff"
     },
     "&.Mui-selected":{
       color: theme.palette.danger.main,
       background: "#fff",
       border: `1px solid ${theme.palette.danger.main}`,
       zIndex: 1
     },
  },
  formGroupButtonGreen:{
    "&:hover":{
      color: theme.palette.success.main,
      background: "#fff",
    },
    "&.Mui-selected":{
      color: theme.palette.success.main,
      background: "#fff",
      border: `1px solid ${theme.palette.success.main}`
    },
  },
  feedbackIcons: {
    width: 20,
    height: 20
  },
  actionsHolder:{
    display: "flex",
    height: 25,
    justifyContent: "flex-end",
    "& button":{
      minWidth: 27,
      width: 27,
      border: `1px solid ${theme.palette.text.veryLight}`,
      padding: "unset",
      color: theme.palette.text.veryLight,
      background: "#fff"
    }
  },
  actionButton: {
    marginRight: 5,
    "&:hover":{
      border: `1px solid ${theme.palette.primary.main}`,
      color: theme.palette.primary.main
    },
    "&.Mui-selected":{
      border: `1px solid ${theme.palette.primary.main}`,
      color: theme.palette.primary.main,
      background: "#fff"
    },
  },
  intent: {
    display: "inline-block",
    padding: "3px 7px",
    border: `${theme.palette.primary.main} 1px solid`,
    borderRadius: 15,
    backgroundColor: "#eff6ff",
    opacity: 0.8,
    fontSize: 11,
    cursor: "default",
    fontWeight: 500,
    letterSpacing: 0.5,
    maxWidth: 150,
    overflow: "hidden",
    whiteSpace: "pre",
    "&:hover > span": {
      transform: "translateX(-100%)",
      left: "100%"
    }
  },
  intentText: {
    transition: "all 2000ms ease-in-out",
    transform: "translateX(0%)",
    position: "relative",
    display: "inline-block",
    left: "0%",
    color: theme.palette.primary.main
  },
  faqIntent: {
    color: theme.palette.secondary.main,
    border: `1px solid ${theme.palette.secondary.main}`,
    backgroundColor: "#fffcf8"
  },
  utterance: {
    display: "inline-block",
    lineHeight: "1.8rem",
    margin: "0 0 10px 0"
  },
  utteranceDate: {
    color: theme.palette.text.disabled,
    fontSize: 11,
    fontWeight: 300,
    fontStyle: "italic"
  },
  timeIcon: {
    height: 12,
    color: "gray",
    display: "inline-block"
  },
  originalAnswer: {
    color: "red",
    fontSize: 12
  },
  aboveTreshold: {
    color: "red",
    fontWeight: 500
  },
  groupLabel: {
    color: theme.palette.text.disabled,
    fontWeight: 400
  },
  resultCount: {
    color: theme.palette.text.disabled,
    fontSize: 13,
    marginTop: 3,
    display: "inline-block" 
  },
  formContent: {
    display: "flex",
    padding: 27,
    "&>div:first-child":{
      marginRight: 5
    }
  }
    
});
